// Discounts extension (admin side): the scheduled price reductions.
// The tab is the old catalog editor's DiscountsTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { ReceiptPercentIcon } from "@heroicons/react/24/outline"
import DiscountsTab from "./DiscountsTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "discounts",
  label: "Discounts",
  description: "Scheduled percent discounts on the product",
  section: {
    component: catalogSection(DiscountsTab),
    label: "Discounts",
    icon: ReceiptPercentIcon,
    order: 1300,
    visible: catalogVisible("discounts"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
